import React from "react";
import { Form } from "semantic-ui-react";
import MyDropzone from "./MyDropzone";
import { useExtLabels } from './extLabels'


const LogoUpload = ({ model, errors = {}, onChange, disabled }) => {
    const l = useExtLabels()

    const handleFileDrop = (key, files) => {
        onChange({ ...model, [key]: files[0] });
    };

    return (
        <React.Fragment>
            <h3>{l('Logotyp')}</h3>
            <div className="ui grid">
                <div className="sixteen wide column required field">
                    <Form.Field error={!!errors.vector}>
                        <MyDropzone
                            disabled={disabled}
                            onDropAccepted={files => handleFileDrop("vector", files)}
                            multiple={false}
                            className={model.vector ? "dropzone uploaded" : "dropzone"}
                            maxSize={5 * 1024 * 1024}
                        >
                            {!model.vector && (
                                <div className="required field">
                                    <label>{l('Przeciągnij logotyp zgłaszanego podmiotu')}</label>
                                    <br />
                                    <small>{l('(format wektorowy: svg lub eps; maksymalny rozmiar 1MB)')}</small>
                                </div>
                            )}
                            {model.vector && <div>{l('Logotyp gotowy do przesłania')}: {model.vector.name}</div>}
                        </MyDropzone>
                    </Form.Field>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LogoUpload;
